import React from 'react'
import Icon from '../tntd-icon'

export default (props) => <Icon {...props} />
